import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { ApolloProvider } from '@apollo/client/react'
import { apolloClient } from './lib/graphql/apollo-client'
import App from './App'
import './index.css'
import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/600.css'
import '@fontsource/inter/700.css'
import '@fontsource/jetbrains-mono/400.css'
import { socket, SocketContext } from './lib/socket'
import { ReduxProvider } from '@/components/providers/redux-provider'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <SocketContext.Provider value={socket}>
    <React.StrictMode>
      <ReduxProvider>
        <ApolloProvider client={apolloClient}>
          <HelmetProvider>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </HelmetProvider>
        </ApolloProvider>
      </ReduxProvider>
    </React.StrictMode>
  </SocketContext.Provider>,
)